export default {
  banner: ['Talent ', 'Bank'],
  title: 'Register in our talent bank',
}
